import {
  CHILD_ABOUT_STEP,
  CHILD_ABOUT_YOU_STEP,
  CHILD_PRICE_STEP,
} from "Components/Features/CheckPrice/Products/LifeProducts/Child";

import { JACKSON_MAGIC_DELETE_KEYWORD } from "Store/addProductToCart/productMappers";
import { INSURANCE_NAME_VALUE } from "Store/interfaces/products";
import { reverseAndPadDDMMYYYY } from "Utils/dateUtils";
import { nullableFormBooleanToNullableBoolean } from "Utils/formUtils";

export type ChildProductBackend = {
  name: INSURANCE_NAME_VALUE;
  childFirstName: string;
  childDateOfBirth: string;
  isScandinavianCitizen?: boolean | null;
  isStayingInNorwayForMoreThanFiveYears?: boolean | null;
  childLastName?: typeof JACKSON_MAGIC_DELETE_KEYWORD;
  childNin?: typeof JACKSON_MAGIC_DELETE_KEYWORD;
  relatedChildProductId?: string;
};

export function mapToCommerceChild(
  data: {
    [key: string]: any;
  },
  type: INSURANCE_NAME_VALUE.CHILD | INSURANCE_NAME_VALUE.AKA_CHILD,
): ChildProductBackend {
  const formValues = data.formData;
  const childFirstName: string = formValues[CHILD_ABOUT_STEP.id].childFirstName;
  const childDateOfBirth = reverseAndPadDDMMYYYY(
    formValues[CHILD_ABOUT_STEP.id].childBirthDate,
  );
  const isScandinavianCitizen = nullableFormBooleanToNullableBoolean(
    formValues[CHILD_ABOUT_YOU_STEP.id].isScandinavianCitizen,
  );
  const isStayingInNorwayForMoreThanFiveYears =
    isScandinavianCitizen === true
      ? null
      : nullableFormBooleanToNullableBoolean(
          formValues[CHILD_ABOUT_YOU_STEP.id]
            .isStayingInNorwayForMoreThanFiveYears,
        );

  const relatedChildHealthProductId =
    formValues[CHILD_PRICE_STEP.id].relatedChildHealthProductId;

  const mappedChildProduct = {
    name:
      type === INSURANCE_NAME_VALUE.AKA_CHILD
        ? INSURANCE_NAME_VALUE.AKA_CHILD
        : INSURANCE_NAME_VALUE.NEW_CHILD,
    coverageGroup: data.coverage,
    childFirstName,
    childDateOfBirth,
    isScandinavianCitizen,
    isStayingInNorwayForMoreThanFiveYears,
    relatedChildHealthProductId,
  };

  if (
    data.storedProduct &&
    data.storedProduct.childLastName &&
    childFirstName.localeCompare(data.storedProduct.childFirstName) !== 0
  ) {
    return {
      ...mappedChildProduct,
      childLastName: JACKSON_MAGIC_DELETE_KEYWORD,
      childNin: JACKSON_MAGIC_DELETE_KEYWORD,
    };
  }
  return mappedChildProduct;
}
